import React, { useEffect } from 'react';
import { useWidget } from 'components/Widget/useWidget';
import ChartBody from 'modules/DashboardModule/charts/components/ChartBody';
import ChartLoading from 'components/charts/components/ChartLoading';
import NoResultFound from 'components/charts/components/NoResultFound';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ninjaApi from 'store/redux/apis/ninja.api';

const NetworKChartContent = ({ height, data }) => {
  const { filters, widget_key, chartConfig } = useWidget();
  const { date_from, date_to } = useWidgetDate(widget_key);

  const [getNetworksReportsQuery, { data: reports = {}, isLoading, isFetching }] =
    ninjaApi.useLazyNetworksReportsQuery();

  useEffect(() => {
    const params = {
      date_from: date_from,
      date_to: date_to,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }

    if (params?.date_from) {
      getNetworksReportsQuery(params).unwrap();
    }
  }, [filters, chartConfig?.load_chart]);

  if (isLoading || isFetching) {
    return <ChartLoading height={height} />;
  }

  if (!reports?.length) {
    return <NoResultFound height={height} />;
  }
  return <ChartBody height={height} data={reports} />;
};

export default NetworKChartContent;
